import type { IntlKey } from 'locales';
import { ModalHeader, ModalTitle, Spinner } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import type { LoadingStatus } from 'utils/status';

interface Props {
  title: IntlKey;
  loadingStatus: LoadingStatus;
  onClosed: () => void;
}
export function ScheduledRunModalHeader({ loadingStatus, title, onClosed }: Props) {
  return (
    <ModalHeader onToggle={onClosed} closeButton>
      <ModalTitle as="h5">
        <FormattedMessage id={title} />
        {loadingStatus === 'loading' && <Spinner className="ms-1" size="sm" />}
      </ModalTitle>
    </ModalHeader>
  );
}
